import * as React from 'react';

import styles from './subject.module.css';

type Props = {
    subject: string;
};

export const Subject = (props: Props) => {
    const {subject} = props;

    return <div className={styles['subject-container']}>{subject}</div>;
};
